import posthog from "posthog-js";

export function usePostHog() {
  posthog.init("phc_geaLNdrUnhAdDtuSXiHYwCv28OUMS9uoVo630Om3y8V", {
    api_host: "https://us.i.posthog.com",
    defaults: "2025-05-24",
    person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
  });

  return { posthog };
}
